import React, { Fragment } from 'react'
import './firebaseInit' // Initialize Firebase
import { Route, Switch, Redirect } from 'react-router-dom'
import HomePage from './pages/HomePage'
import ProfilePage from './pages/ProfilePage'
import TreePage from './pages/TreePage'
import SignIn from './pages/SignIn'
import { UserContextProvider } from './contexts/UserContext'
import { MemberContextProvider } from './contexts/MemberContext'
import { LeavesContextProvider } from './contexts/LeavesContext'
import NotificationsPage from './components/organisms/NotificationsPage'
import SignUp from './pages/SignUp'
import PublicRoute from './routes/PublicRoute'
import GlobalStyle from '../src/globalStyles'
import NotificationsContextProvider from './contexts/NotificationsContext'
import { CustomThemeContextProvider } from './contexts/CustomThemeContext'
import LayoutRoute from './components/general/LayoutRoute'
import TreeLayout from './components/general/TreeLayout'
import TreesPage from './pages/TreesPage'
import SettingsPage from './components/organisms/SettingsPage'
import TutorialsPage from './components/organisms/TutorialsPage'
import SignOut from './pages/SignOut'
import 'toasted-notes/src/styles.css'
import DashboardLayout from './components/general/DashboardLayout'
import WindowSizeContextProvider from './contexts/WindowSizeContext'

const App = () => {
    return (
        <Fragment>
            <CustomThemeContextProvider>
                <GlobalStyle />
                <div className="App">
                    <UserContextProvider>
                        <MemberContextProvider>
                            <LeavesContextProvider>
                                <NotificationsContextProvider>
                                    <WindowSizeContextProvider>
                                        <Switch>
                                            <LayoutRoute
                                                exact={true}
                                                path="/"
                                                component={HomePage}
                                                routeType={Route}
                                            />
                                            <LayoutRoute
                                                layout={DashboardLayout}
                                                exact={true}
                                                path="/profile"
                                                component={ProfilePage}
                                                authenticatedRoute={true}
                                            />
                                            <LayoutRoute
                                                path="/trees/:treeId"
                                                layout={TreeLayout}
                                                component={TreePage}
                                                routeType={Route}
                                            />
                                            <LayoutRoute
                                                path="/trees"
                                                layout={DashboardLayout}
                                                component={TreesPage}
                                                authenticatedRoute={true}
                                            />
                                            <LayoutRoute
                                                path="/notifications"
                                                layout={DashboardLayout}
                                                component={NotificationsPage}
                                                authenticatedRoute={true}
                                            />
                                            <LayoutRoute
                                                path="/settings"
                                                layout={DashboardLayout}
                                                component={SettingsPage}
                                                authenticatedRoute={true}
                                            />
                                            <LayoutRoute
                                                path="/tutorials"
                                                layout={DashboardLayout}
                                                component={TutorialsPage}
                                            />
                                            <LayoutRoute
                                                path="/sign-in"
                                                component={SignIn}
                                                routeType={PublicRoute}
                                            />
                                            <LayoutRoute
                                                path="/sign-up"
                                                component={SignUp}
                                                routeType={PublicRoute}
                                            />
                                            <LayoutRoute
                                                path="/sign-out"
                                                component={SignOut}
                                                routeType={PublicRoute}
                                                authenticatedRoute={true}
                                            />
                                            <Redirect to="/" />
                                        </Switch>
                                    </WindowSizeContextProvider>
                                </NotificationsContextProvider>
                            </LeavesContextProvider>
                        </MemberContextProvider>
                    </UserContextProvider>
                </div>
            </CustomThemeContextProvider>
        </Fragment>
    )
}

export default App
